import { render, staticRenderFns } from "./SearchAndAssignProducts.vue?vue&type=template&id=ed2e411e"
import script from "./SearchAndAssignProducts.vue?vue&type=script&lang=js"
export * from "./SearchAndAssignProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports